import React from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import NCR from "./ncr";
import SOP from "./sop";
import Checklist from "./checklist";
import JobMethodology from "./jobmethodology";
export default function QualityRecord({ project }) {
  return (
    <React.Fragment>
      <Tabs>
        <div className="row" id="risk-register">
          <div className="col-12">
            <TabList>
              <Tab>NCR</Tab>
              {/* <Tab>SOP</Tab> */}
              <Tab>Checklist</Tab>
              <Tab>Job Methodology</Tab>
            </TabList>
          </div>
          {/* <hr /> */}
        </div>
        <div className="row" style={{ marginLeft: 0 }}>
          <TabPanel>
            <NCR project={project} />
          </TabPanel>
          {/* <TabPanel>
            <SOP project={project} />
          </TabPanel> */}
          <TabPanel>
            <Checklist project={project} />
          </TabPanel>
          <TabPanel>
            <JobMethodology project={project} />
          </TabPanel>
        </div>
      </Tabs>
    </React.Fragment>
  );
}
